import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { useDpFanUserHasInterests } from '@/data/Content/DpFan/userHasInterests';

export const useDpFanRecommendedContent = (_emsName: string) => {
	const { isLoadingUserInterests, isUserLoggedIn, hasCustomInterests } = useDpFanUserHasInterests();

	const { data: processedContent, loading: isLoadingContentRecommendation } =
		useContentRecommendation(
			!isLoadingUserInterests && isUserLoggedIn && !hasCustomInterests ? _emsName : undefined
		);

	return {
		isLoadingUserInterests,
		isUserLoggedIn,
		isLoadingContentRecommendation,
		hasCustomInterests,
		processedContent,
	};
};
